export default "__VITE_ASSET__uDgQfKsU__"